import { TranslationService } from '@sdbn/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-truck-info-panel',
  templateUrl: './truck-info-panel.component.html',
  styleUrls: ['./truck-info-panel.component.scss']
})
export class TruckInfoPanelComponent {

  @Input() identifier: string;

  @Input() carrier: string;

  @Input() driver: string;

  constructor(public translationService: TranslationService) { }
}
